import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: theme.app.borderRadius.lg,
    padding: '30px',
    maxWidth: '500px',
    width: '90%',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
    animation: '$fadeIn 0.2s ease-in-out'
  },
  title: {
    fontSize: '20px',
    fontWeight: 500,
    color: theme.app.colors.text.primary,
    marginBottom: '15px',
    marginTop: 0
  },
  message: {
    fontSize: theme.app.typography.body.fontSize,
    color: '#333',
    marginBottom: '25px',
    lineHeight: '1.5',
    textAlign: 'start'
  },
  buttons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      '& button': {
        width: '100%'
      }
    }
  },
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
      transform: 'scale(0.95)'
    },
    to: {
      opacity: 1,
      transform: 'scale(1)'
    }
  }
}))
